export const HEADING_FONT = `"Metal", serif;`;
export const HEADING_ALTERNATIVE = HEADING_FONT;
export const BODY_FONT = `"Benne", serif;`;
export const BODY_ALTERNATIVE = BODY_FONT;

